import React, { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { setUserSettings } from '../settings/userSettings'
import {
  calendarSettingsSelector,
  setZoomLevelValue,
} from '../store/calendarSlice'

import {
  SlidersLabels,
  ZoomSlider,
  ZoomSliderText,
  ZoomSliderTextWrapper,
  ZoomSliderWrapper,
} from './style'

export const ZoomInOutPicker = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [zoomValue, setZoomValue] = useState<string>('30')

  const calendarSettings = useAppSelector(calendarSettingsSelector)
  const colorContrast = calendarSettings.colorContrast
  const zoomLevelValue = calendarSettings.zoomLevelValue

  useEffect(() => {
    if (zoomLevelValue) {
      setZoomValue(zoomLevelValue)
    }
  }, [zoomLevelValue])

  const onZoomSliderChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    setZoomValue(value)
  }

  const onZoomUp = () => {
    setUserSettings({ zoomLevelValue: zoomValue })
    dispatch(setZoomLevelValue({ zoomLevelValue: zoomValue }))
  }

  return (
    <ZoomSliderWrapper>
      <SlidersLabels>
        <ZoomSlider
          value={zoomValue}
          type="range"
          min="30"
          max="100"
          step="10"
          onChange={e => {
            onZoomSliderChange(e)
          }}
          onMouseUp={onZoomUp}
        />
        <span>{t('Zoom In / Out')}</span>
      </SlidersLabels>
      <ZoomSliderTextWrapper colorContrast={colorContrast}>
        <ZoomSliderText>{zoomValue}</ZoomSliderText>
      </ZoomSliderTextWrapper>
    </ZoomSliderWrapper>
  )
}
